import React, { Component } from 'react';
import { Grid, Button, CircularProgress, Typography, IconButton } from '@material-ui/core';
import Dropzone from 'react-dropzone'
import { Delete } from '@material-ui/icons';

type Props = {
    sendSupplierOfferBusy: boolean,
    sendSupplierOffer: (fiiles: File) => void,
    sendSupplierOfferSucced: boolean | null,
    onCancel: () => void,
    onSuccess: () => void
}

type State = {
    file: File | null,
    uploaded: boolean
}

class OfferFileLoader extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            file: null,
            uploaded: false
        };
    }

    componentDidUpdate(prevProps: Props){
        if((prevProps.sendSupplierOfferSucced === null || prevProps.sendSupplierOfferSucced === false) && this.props.sendSupplierOfferSucced === true){
            this.props.onSuccess()
            this.setState({uploaded: true})
        }
    }

    render() {
        return (
            <div>
                {!this.props.sendSupplierOfferBusy ? (
                    <div>
                        {this.state.uploaded === false ?
                            <Grid container>
                                <Grid item xs={12} sm={12} style={{ paddingTop: '20px' }}>
                                    <Dropzone accept={['text/csv', 'application/pdf', '.csv']} onDrop={acceptedFiles => acceptedFiles[0] ? this.setState({ file: acceptedFiles[0] }) : console.log('WrongFile')}>
                                        {({ getRootProps, getInputProps }) => (
                                            <section>
                                                <div {...getRootProps()} style={{ border: 'solid 1px black', textAlign: "center" }}>
                                                    <input {...getInputProps()} />
                                                    <Typography style={{ padding: '50px' }} variant="h3">Drop file with offers here or click</Typography>
                                                </div>
                                            </section>
                                        )}
                                    </Dropzone>
                                </Grid>

                                {this.state.file &&
                                    <Grid item xs={12}>
                                        <Grid container alignContent="center" alignItems="center" style={{ paddingTop: '10px' }}>
                                            <Grid style={{ textAlign: 'center' }} item sm={2}>
                                                <IconButton onClick={() => this.setState({ file: null })}><Delete /></IconButton>
                                            </Grid>
                                            <Grid item sm={10}>
                                                <Typography variant="h4">{this.state.file!.name}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }


                                <Grid item xs={12} sm={6} style={{ paddingTop: '15px', textAlign: 'center' }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => { this.setState({ file: null }); this.props.onCancel() }}>
                                        Cancel
                                    </Button>
                                </Grid>

                                <Grid item xs={12} sm={6} style={{ paddingTop: '15px', textAlign: 'center' }}>
                                    <Button variant="contained" color="primary"
                                        disabled={this.state.file === null}
                                        onClick={() => { this.props.sendSupplierOffer(this.state.file!) }}>Send
                                    </Button>
                                </Grid>
                            </Grid>
                            :
                            <Grid container>
                                <Grid item xs={12} sm={12} style={{ paddingTop: '15px', textAlign: 'center' }}>
                                    <Typography variant="h2" color="primary">Your offer was succesfully uploaded!</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} style={{ paddingTop: '15px', textAlign: 'center' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => { this.setState({ file: null, uploaded:false }); this.props.onCancel() }}>
                                        Close
                                    </Button>
                                </Grid>
                            </Grid>
                        }

                    </div>
                ) :
                    <div style={{ width: '100%', textAlign: 'center' }}>
                        <CircularProgress size={50}></CircularProgress>
                    </div>
                }
            </div>
        );
    }
}

export default OfferFileLoader;